
<!-- Выбор атрибута из списка и установ значения атрибута -->

<template>

	<div>

		<attr_select class="mb-2" v-model="attr_key" :attrs="attrs" ref="select" v-on:input="attr_changed"/>
		<b-row class="mb-2"><b-col cols="4">Тип параметра:</b-col><b-col>{{ attr | format_type }}</b-col></b-row>

		<b-form-group label="Значение" label-for="value_input">

			<set_value :attr="attr" :value="value" v-on:input="input" :validation="validation" />

		</b-form-group>

	</div>

</template>

<script>

import attr_select from "./select"
import set_value from "./set_value"

export default
{
	props :
	{
		attrs : Array,
		validation : { type : Object, default : () => null }
	},

	components:
	{
		attr_select,
		set_value,
	},

	data()
	{
		return {
			
			attr : null,
			attr_key : null,

			date_format : { year: "numeric", month: "numeric", day: "numeric" },

			value : null,

		}
	},

	filters :
	{
		format_type(attr)
		{
			if(attr == null)
				return ""

			if(attr.type == "number")
				return "Число"
			else if(attr.type == "date")
				return "Дата"
			else if(attr.type == "time")
				return "Время"
			else if(attr.type == "bool")
				return "Булево"
			else if(attr.reference)
				return "Строка (справочник)"
			
			return "Строка"
		}
	},

	methods :
	{
		check()
		{
			const state = this.$refs.select.check()

			return state
		},

		reset()
		{
			this.attr = null
			this.attr_key = null
		},

		attr_changed(attr_key)
		{
			this.attr = this.attrs.find(attr => attr_key == attr.key)

			if(this.attr.type == "bool")
			{
				this.value = false
				this.input(false)
			}
		},

		input(value)
		{
			this.value = value

			this.$emit("input", { key : this.attr_key, value : value })
		},
	}
}

</script>

